/* import __COLOCATED_TEMPLATE__ from './date-view-select.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface PoWorkbenchDateViewSelectSignature {
  Args: {
    disabled: unknown;
    fill: unknown;
    inline: unknown;
    isLoading: unknown;
    label: unknown;
    onChange: unknown;
    selectedDateField: unknown;
    size: unknown;
  };
  Element: HTMLElement;
}

const PoWorkbenchDateViewSelectComponent =
  templateOnlyComponent<PoWorkbenchDateViewSelectSignature>();

export default PoWorkbenchDateViewSelectComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'PoWorkbench::DateViewSelect': typeof PoWorkbenchDateViewSelectComponent;
    'po-workbench/date-view-select': typeof PoWorkbenchDateViewSelectComponent;
  }
}
